import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/bell"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.322 7.52661C13.4107 7.6131 13.5037 7.70371 13.6 7.8C14.3 8.4 15 9 15 10C15 11.7362 12.9479 12.4727 10.9922 12.7818C10.9766 12.7842 10.961 12.7867 10.9454 12.7891C9.76367 12.9719 8.62344 13 8 13C7.36834 13 6.20618 12.9711 5.00781 12.7818C3.05211 12.4727 1 11.7362 1 10C1 9 1.7 8.4 2.4 7.8C2.49629 7.70371 2.58926 7.6131 2.67802 7.52661C3.2345 6.98428 3.625 6.60371 3.625 6V5C3.625 2.2 5.55 0 8 0C10.45 0 12.375 2.2 12.375 5V6C12.375 6.60371 12.7655 6.98428 13.322 7.52661ZM8 16C6.6231 16 5.46285 15.0724 5.11007 13.808C6.29526 13.9755 7.3987 14 8 14C8.60129 14 9.70473 13.9755 10.8899 13.808C10.5371 15.0724 9.37689 16 8 16Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Bell16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Bell16 = createIcon(IconComponent);